import { Stack, Box, Text, TextLink } from '@n26/nxd'
import { useTranslation } from 'react-i18next'
import styles from './Footer.module.css'

const LEGAL_LINKS = [
  {
    labelKey: 'footer.privacyPolicy',
    href: 'https://n26.com/en-eu/privacy-policy',
  },
  {
    labelKey: 'footer.cookiePolicy',
    href: 'https://n26.com/en-eu/cookie-policy',
  },
  {
    labelKey: 'footer.legalNotice',
    href: 'https://n26.com/en-eu/legal-notice',
  },
] as const

export const Footer = () => {
  const { t } = useTranslation()
  return (
    <footer role='contentinfo'>
      <Box as='nav' padding='24' backgroundColor='neutral' className={styles.nav}>
        <Stack
          direction={{ mobile: 'vertical', desktop: 'horizontal' }}
          space={{ mobile: '8', desktop: '16' }}
        >
          <Text>&copy;&nbsp;N26&nbsp;{new Date().getFullYear()}</Text>

          {LEGAL_LINKS.map(({ labelKey, href }) => (
            <TextLink
              key={href}
              href={href}
              variant='subtle'
              target='_blank'
              rel='noreferrer'
            >
              {t(labelKey)}
            </TextLink>
          ))}
        </Stack>
      </Box>
    </footer>
  )
}
